<!-- 通过登录页面登录 -->
<template>
  <div id="platfrom_login_cctv">
    <span
      class="bgImg"
      :class="loading ? '' : 'unAnimation'"
      :style="{ backgroundImage: loginBg }"
    ></span>
    <span class="loginBg_pop"></span>
    <span
      class="rightTop_logo"
      :style="{ backgroundImage: loginPageLogo }"
    ></span>
    <div class="login_pop">
      <span class="pop_login" :style="{ backgroundImage: loginPopLogo }"></span>
      <div class="input_area">
        <div class="inputDiv">
          <el-form @submit.native.prevent="confirmLogin()">
            <el-input
              placeholder="请输入您的邮箱"
              prefix-icon="el-icon-message"
              v-model.trim="email"
            ></el-input>
          </el-form>
        </div>
        <div class="inputDiv">
          <el-form @submit.native.prevent="confirmLogin()">
            <el-input
              placeholder="请输入您的密码"
              show-password
              prefix-icon="el-icon-lock"
              v-model.trim="password"
            ></el-input>
          </el-form>
        </div>
      </div>
      <div class="loginBtn" @click="confirmLogin">登录</div>
    </div>
    <div class="footer_area">
      <!-- <span class="footer_floor">
          <span>电话：18500084973</span>
          <span>邮箱：du_yang@newautogroup.cn</span>
          <span>地址：北京市海淀区西四环北路新奥特大厦</span>
        </span> -->
      <span class="footer_floor">
        <!-- 北京晓数聚数字科技有限公司 版权所有 -->
        <a class="ICPbtn" href="https://beian.miit.gov.cn/" target="_blank">
          京ICP备06036302号-2
        </a>
        <a class="ICPbtn" href="https://beian.miit.gov.cn/" target="_blank">
          京ICP备10003349号
        </a>
        <a
          class="ICPbtn"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?spm=C96370.PPDB2vhvSivD.EJNuevatPcN6.5&recordcode=11000002000018"
          target="_blank"
        >
          京公网安备 11000002000018号
        </a>
        京网文[2014]0383-083号
      </span>
    </div>
  </div>
</template>
<script>
import { https_user_login } from '@api/platfrom_base_api'
import customizeProMixins_data_mixin from '@customizeProMixins/index.js'
export default {
  name: 'platfrom_login_cctv',
  mixins: [customizeProMixins_data_mixin],
  data() {
    return {
      // 账号|邮箱
      email: '',
      // 密码
      password: '',
      showPassword: true,
      // 错误提示文案
      errors: '',
      // 密码格式是否通过验证
      passwordSuccess: false,
      // 邮箱是否通过验证
      emailSuccess: false,
      // 防止连续点击
      loading: false,
      // isLogin: false, //登录后关闭动画
    }
  },
  created() {
    this.init()
  },
  mounted() {},
  computed: {
    loginBg() {
      const imgStr = require(`@src/assets/images/platfrom_${this.customizePro}/login_bg.png`)
      return `url(${imgStr})`
    },
    loginPopLogo() {
      const imgStr = require(`@src/assets/images/platfrom_${this.customizePro}/login_pop_logo.png`)
      return `url(${imgStr})`
    },
    loginPageLogo() {
      const imgStr = require(`@src/assets/images/platfrom_mixtmt/loginPage_log.png`)
      return `url(${imgStr})`
    },
  },
  methods: {
    init() {
      if (this.$localStorage.getItem('mixtmt_userInfo')) {
        const mixtmt_userInfo = JSON.parse(
          this.$localStorage.getItem('mixtmt_userInfo')
        )
        this.email = mixtmt_userInfo.email
        this.password = this.root_passport.decrypt(mixtmt_userInfo.email)
      }
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    checkEmailPassword() {
      if (this.email == '') {
        this.errors = '请输入邮箱'
        console.debug(this.errors)
        return false
      }
      if (this.password == '') {
        this.errors = '请输入密码'
        console.debug(this.errors)
        return false
      }
      return true
    },
    //确认登录
    confirmLogin() {
      this.errors = ''
      if (!this.loading && this.checkEmailPassword()) {
        this.loading = true
        https_user_login('/api', this.$axios, {
          email: this.email,
          pwd: this.root_passport.encrypt(this.password),
          domain: 'data.mixtmt.com',
        })
          .then((response) => {
            const res = response.data
            console.debug(res)

            if (res.status == 0) {
              const query = this.$route.query
              // 存储信息到localstorage
              // let identy = res.data.identy; //判断能进入哪个权限页面
              this.$localStorage.setItem(
                'mixtmt_userInfo',
                JSON.stringify(res.data)
              )

              if (query.website && query.redirect_url) {
                // 跳转到其他站点
                console.debug('跳转到其他站点')
                window.location = query.redirect_url
              } else {
                console.debug('platfromHomeIndex')
                this.$router.replace({
                  name: 'platfromHomeIndex',
                })
              }
            } else {
              if (res.message) {
                // message：null，因此不弹出警示框（一般404 || 500的时候）；
                // message不为null的时候展示警示框；
                this.$message({
                  showClose: true,
                  message: res.message ? res.message : '服务器异常，请稍后再试',
                  type: 'warning',
                })
              }
            }
          })
          .catch((err) => {
            console.debug(err)
          })
        this.loading = false
      } else {
        this.$message({
          showClose: true,
          message: this.errors,
          type: 'warning',
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/common/css/loginVar.scss';
@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}
#platfrom_login_cctv {
  position: relative;
  .bgImg {
    display: block;
    width: 100vw;
    height: 100vh;
    /* background-size: cover; */
    background-repeat: no-repeat;
    /* background-size: 160% 150%; */
    background-size: auto 100%;
    &.isAnimation {
      animation: gradient 25s linear infinite;
    }
    &.unAnimation {
      background-size: cover;
      /* background-position: center;  */
      background-position: center bottom;
    }
  }
  .loginBg_pop {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10;
    width: 100vw;
    height: 100vh;
    background-color: rgba(26, 26, 26, 0.2);
  }
  .rightTop_logo {
    position: fixed;
    top: 1.388vw;
    /* left: 1.388vw; */
    left: 2.778vw;
    z-index: 10;
    width: 6.94vw;
    height: 6.94vw;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
  }
  .login_pop {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 100;
    width: 31.1vw;
    height: calc(22.64vw + 5.246vw);
    /* background-color: rgba(26, 26, 26, 0.5); */
    border-radius: 0.694vw;
    transform: translate(-50%, -50%);
    padding: 2.083vw 2.778vw;
    .pop_login {
      display: block;
      height: 6vw;
      background-size: 100% auto;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
    .input_area {
      padding-top: 1.11vw;
      .inputDiv {
        margin-bottom: 1.388vw;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .loginBtn {
      margin-top: 2.778vw;
      width: 100%;
      height: 2.778vw;
      background-color: $loginBtnBgColor;
      color: $loginBtnColor;
      text-align: center;
      font-size: 0.972vw;
      line-height: 2.778vw;
      border-radius: 0.277vw;
    }
  }
  .footer_area {
    position: absolute;
    left: 50%;
    bottom: 1.388vw;
    z-index: 50;
    width: 100%;
    padding: 0 10%;
    transform: translateX(-50%);
    font-size: 0.972vw;
    line-height: 1.666vw;
    color: #fff;
    .footer_floor {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      .ICPbtn {
        display: inline-block;
        color: rgba(80, 150, 252, 1);
        text-decoration: underline;
        padding: 0 0.694vw;
        &:hover {
          color: rgba(255, 255, 255, 0.8);
        }
      }
      span {
        padding-left: 0.694vw;
      }
    }
  }
}
.mixtmt_pc {
  #platfrom_login_cctv {
    .login_pop {
      .loginBtn {
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
</style>

<style lang="scss">
@import '@/common/css/loginVar.scss';
.login_pop {
  .inputDiv {
    .el-input__inner {
      height: 2.778vw;
      line-height: 2.778vw;
      padding: 0 1.805vw;
      font-size: 0.972vw;
      background-color: rgba(238, 238, 299, 0);
      border: 1px solid rgba(238, 238, 299, 0.5);
      border-radius: 0.277vw;
      color: $inputActColor;
    }
    input::-webkit-input-placeholder {
      color: $inputPlaceholderColor;
      font-weight: lighter;
    }

    input::-moz-placeholder {
      color: $inputPlaceholderColor;
      font-weight: lighter;
    }

    input::-ms-input-placeholder {
      color: $inputPlaceholderColor;
      font-weight: lighter;
    }

    input::-moz-placeholder {
      color: $inputPlaceholderColor;
      font-weight: lighter;
    }
    .el-input__prefix {
      left: 1px;
      .el-input__icon {
        width: 1.805vw;
        line-height: 2.778vw;
        text-align: center;
        color: $loginMainColor;
      }
    }
    .el-input__suffix {
      right: 1px;
      .el-input__icon {
        width: 1.805vw;
        line-height: 2.778vw;
        text-align: center;
      }
    }
    .el-input.is-active .el-input__inner,
    .el-input__inner:focus {
      border-color: $loginMainColor;
      outline: 0;
    }
  }
}
.mixtmt_pc {
  #platfrom_login_cctv {
    .login_pop {
      .inputDiv {
        .el-input__suffix {
          &:hover {
            .el-input__icon {
              color: $loginMainColor;
            }
          }
        }
      }
    }
  }
}
</style>
